<template>
  <div class="pg-monaco-editor-api">
    <PgMonacoEditor
      class="pg-monaco-editor-api__edit"
      :valueType="valueType"
      :language="language"
      :value="value"
      @input="input"
    />
    <div>
      <Button type="text" v-if="!!url" :loading="loading" @click="getTemplate">选择模板</Button>
    </div>

    <Dialog
      custom-class="pg-dialog pg-monaco-editor-api__dialog"
      top=""
      append-to-body
      :title="title"
      :visible.sync="visible"
      width="800"
    >
      <div class="pg-monaco-editor-api__left">
        <div
          class="pg-monaco-editor-api__left-item"
          :class="{ 'pg-monaco-editor-api__left-item--active': propertieId === item.id }"
          v-for="(item, index) in properties"
          :key="index"
          @click="propertieSelect(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="pg-monaco-editor-api__right">
        <PgMonacoEditor
          class="pg-monaco-editor-api__right-edit"
          :valueType="valueType"
          :language="language"
          :value="propertie"
          @input="propertieInput"
        />
        <PgTable
          class="pg-monaco-editor-api__table"
          showOverflow="title"
          :height="268"
          :data="fields"
          :column="column"
        ></PgTable>
      </div>
      <template #footer>
        <Button type="primary" round @click="submit">确定</Button>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import PgMonacoEditor from './monaco-editor.vue'
import { Dialog, Button } from 'element-ui'
import { ref, shallowRef } from 'vue'
import { get } from '../../../utils/index'
import { pgMessage } from '../../message/index'
import { PgTable } from '../../table/index'

const emit = defineEmits(['input'])
const props = defineProps({
  value: [Object, String, Array],
  language: String,
  valueType: {
    type: String,
    default: 'object',
  },
  title: {
    type: String,
    default: '选择模板',
  },
  url: String,
  param: Object,
  column: {
    type: [Object, Array],
    default: () => [
      {
        property: 'key',
        label: '属性名',
      },
      {
        property: 'value',
        label: '说明',
      },
      {
        property: 'type',
        label: '类型',
      },
      {
        property: 'note',
        label: '默认值',
      },
    ],
  },
})

const properties = shallowRef([])
const fields = shallowRef([])
const propertie = shallowRef(null)
const propertieId = ref(null)

const visible = ref(false)
const loading = ref(false)
const getTemplate = async () => {
  loading.value = true
  const [res, error] = await get(props.url, props.param)
  loading.value = false

  if (res?.data?.properties) {
    visible.value = true
    properties.value = res.data.properties
    fields.value = res.data.fields
  } else {
    pgMessage.error(error?.msg ?? '未查询到该组件的配置')
  }
}

const propertieSelect = (item) => {
  propertie.value = item.property
  propertieId.value = item.id
}

const propertieInput = (val) => {
  propertie.value = val
}
const submit = () => {
  emit('input', propertie.value)
  visible.value = false
}
const input = (val) => {
  emit('input', val)
}
</script>
<style lang="scss">
@import '../style/monaco-editor-api.scss';
</style>
